<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IWizHL/tc-custom/9780802193193.jpg?1703426607218" alt="This image is the cover for the book Crush"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crush
      </h1>
      <p class="bookDescription body article font2">
        <b>This debut novel of a Frenchwoman’s obsessive affair is </b><b>“a little book that astonishes, by the fierceness of its outlook, the rawness of its tone” (<i>Magazine Littéraire</i>).</b><br/>  <br/> Amélie is a thirty-year-old haute bourgeoisie wife of a distant husband and mother of two picture-perfect daughters. One evening at a service station on the outskirts of the Bois de Boulogne, she meets a man named David and immediately steps into a new life of erotic sensuality. Twenty years her senior, darkly handsome, and almost embarrassingly virile, he is a suave filmmaker, a confirmed bachelor, and the perfect match for the perfect affair—but one with a twist.<br/>  <br/> Amélie is not the typical lonely wife, starving for affection. Capricious, snobbish, and sometimes deceitful, she is ravenously hungry for pleasure. Written with cool-headed intensity and sexual heat, <i>Crush</i> is an unforgettable odyssey through the wilds of desire into the badlands of erotic obsession.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cécile de La Baume, Ramona Desfleurs
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove/Atlantic, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0661caf8